import { StyleSheet } from "react-native-unistyles";

const stylesheet = StyleSheet.create(({ spacing }) => ({
  search: {
    marginBottom: spacing(8),
  },
  section: {
    gap: spacing(4),
    marginBottom: spacing(8),
  },
  recentHeader: {
    justifyContent: "center",
  },
  recentTitle: {
    paddingRight: spacing(16),
  },
  clearButton: {
    position: "absolute",
    right: 0,
    top: 0,
    bottom: 0,
    justifyContent: "center",
  },
  recommendationsLane: {
    gap: spacing(4),
  },
  results: {
    gap: spacing(4),
  },
}));

export default stylesheet;
